import { Host } from 'shared/classes/Host';
import { AdminPerson } from './Person';

export class AdminHost extends Host {
  constructor(parameters) {
    super(parameters)

    this.type = 'AdminHost'

    this.update_person = (person_data) => {
      person_data.host = undefined; // prevent circular reference
      this.person(new AdminPerson(person_data));
    };

    parameters.person = parameters.person ?? {};
    if (parameters.person.host) {
      parameters.person.host = undefined; // prevent circular reference
    }
    this.update_person(parameters.person);
  }
}
